import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../lib/api";
import { useAuth } from "../lib/auth";
import { AuthCard, PasswordField, AuthError, AuthNotice } from "../components/AuthUI";

export default function ChangePassword() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const forced = user?.must_change_password;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) { setError("Las dos contraseñas nuevas no coinciden."); return; }
    setBusy(true);
    try {
      const r = await api.post("/auth/change-password", { current_password: current, new_password: next });
      setUser(r.data);
      toast.success("Contraseña actualizada");
      navigate("/estudio", { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="Cambiar contraseña" subtitle="Usá al menos 8 caracteres. Anotala en un lugar seguro." testId="change-password-page">
      {forced && (
        <AuthNotice testId="change-password-forced-notice">
          Estás usando una contraseña temporal. Por seguridad, elegí una propia antes de seguir.
        </AuthNotice>
      )}
      <form onSubmit={submit}>
        <AuthError message={error} />
        <PasswordField label={forced ? "Contraseña temporal" : "Contraseña actual"} id="cp-current" value={current} onChange={(e) => setCurrent(e.target.value)} testId="change-password-current-input" />
        <PasswordField label="Contraseña nueva" id="cp-new" value={next} onChange={(e) => setNext(e.target.value)} testId="change-password-new-input" autoComplete="new-password" />
        <PasswordField label="Repetir contraseña nueva" id="cp-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} testId="change-password-confirm-input" autoComplete="new-password" />
        <button type="submit" disabled={busy} className="pill pill-primary auth-btn w-full" data-testid="change-password-submit-button">
          <KeyRound size={22} /> {busy ? "Guardando…" : "Guardar contraseña nueva"}
        </button>
      </form>
      {!forced && (
        <div className="text-center mt-8">
          <Link to="/estudio/ajustes" className="text-lg font-semibold text-[#A36A00] underline underline-offset-4" data-testid="change-password-back-link">
            Volver a Ajustes
          </Link>
        </div>
      )}
    </AuthCard>
  );
}
